import { KeyValueModel } from "model/api";
import { EnumBalcaoSalao } from "model/enums/enum-balcao-salao";

export const TpBalcaoSalaoMock: KeyValueModel[] = [
    new KeyValueModel(EnumBalcaoSalao.UTILIZA, "Utiliza"),
    new KeyValueModel(EnumBalcaoSalao.NAO_UTILIZA, "Não Utiliza"),
];
